<template>
  <div>
    <tipo-agendamento-dialog
      :is-configurar-tipo-agendamento-dialog-open="isConfigurarTipoAgendamentoDialogOpen"
      :tipo-agendamento-id="tipoAgendamentoId"
      :close-dialog="closeDialog"
      @refetch-data="getTipoAgendamentos"
    />

    <contadores
      :total="contadores.total"
      :ativos="contadores.ativos"
      :inativos="contadores.inativos"
      @alterarFiltro="atualizarFiltro"
    />

    <v-card>
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-text-field
          v-model.trim="search"
          placeholder="Pesquisar"
          outlined
          hide-details
          dense
          class="user-search me-3 mb-4"
          @keyup="getTipoAgendamentos"
        />

        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn
            color="success"
            class="px-4"
            @click.stop="isConfigurarTipoAgendamentoDialogOpen = !isConfigurarTipoAgendamentoDialogOpen"
          >
            <v-icon
              left
              size="25"
              class="mr-1"
            >
              {{ icons.mdiAccountPlusOutline }}
            </v-icon>
            <span>Cadastrar</span>
          </v-btn>
        </div>
      </v-card-text>

      <v-col cols="12">
        <div style="min-height: 4px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          />

          <table-tipo-agendamentos
            :items="tipoAgendamentoDataLocale"
            :selecionar-tipo-agendamento="selecionarTipoAgendamento"
            @refetch-data="getTipoAgendamentos"
          />
        </div>
      </v-col>
    </v-card>
  </div>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'
import { mdiAccountPlusOutline } from '@mdi/js'
import Contadores from '@/components/contadores/Contadores.vue'
import TipoAgendamentoDialog from '@/views/agenda/tipo-agendamento/EditTipoAgendamentoDialog.vue'
import TableTipoAgendamentos from '@/components/tables/TableTipoAgendamento.vue'
import TicketAgendamentoTipoService from '@/services/modules/TicketAgendamentoTipoService'

export default {
  components: {
    Contadores,
    TableTipoAgendamentos,
    TipoAgendamentoDialog,
  },

  setup() {
    const isConfigurarTipoAgendamentoDialogOpen = ref(false)

    const tipoAgendamentoDataLocale = ref([])
    const loading = ref(false)
    const search = ref('')
    const filtroStatus = ref('')
    const qtdItems = ref(0)
    const contadores = ref({
      total: 0,
      ativos: 0,
      inativos: 0,
    })

    async function getTipoAgendamentos(itensPorPagina = 100) {
      qtdItems.value = itensPorPagina
      try {
        tipoAgendamentoDataLocale.value = await TicketAgendamentoTipoService.get(itensPorPagina)

        contadores.value.total = tipoAgendamentoDataLocale.value.length
        contadores.value.ativos = tipoAgendamentoDataLocale.value.filter(ativo => ativo.ativo).length
        contadores.value.inativos = tipoAgendamentoDataLocale.value.filter(ativo => !ativo.ativo).length

        if (search.value) {
          tipoAgendamentoDataLocale.value = tipoAgendamentoDataLocale.value.filter(it => it.nome.toLowerCase().includes(search.value.toLowerCase()))
        }
        if (filtroStatus.value) {
          tipoAgendamentoDataLocale.value = tipoAgendamentoDataLocale.value.filter(e => e.ativo === filtroStatus.value || e.ativo.toString() === filtroStatus.value)
        }

        tipoAgendamentoDataLocale.value.sort((a, b) => new Date(b.dataCadastro) - new Date(a.dataCadastro))
      } finally {
        loading.value = false
      }
    }

    onMounted(async () => { await getTipoAgendamentos() })

    const tipoAgendamentoId = ref(0)

    function selecionarTipoAgendamento(item) {
      tipoAgendamentoId.value = item.id
      isConfigurarTipoAgendamentoDialogOpen.value = true
    }

    function atualizarFiltro(item) {
      filtroStatus.value = item
      getTipoAgendamentos(qtdItems.value)
    }

    async function closeDialog() {
      isConfigurarTipoAgendamentoDialogOpen.value = false
      tipoAgendamentoId.value = 0
    }

    return {
      isConfigurarTipoAgendamentoDialogOpen,
      tipoAgendamentoDataLocale,
      loading,
      search,
      filtroStatus,
      qtdItems,
      contadores,
      getTipoAgendamentos,
      atualizarFiltro,
      tipoAgendamentoId,
      closeDialog,
      selecionarTipoAgendamento,
      icons: {
        mdiAccountPlusOutline,

      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
